module.exports = __webpack_public_path__ + "img/introduction_size_five@2x.3293a76b.png";